import React, { useId } from "react";

interface HeroQuoteCloseProps {
  className?: string;
}

const HeroQuoteClose: React.FC<HeroQuoteCloseProps> = ({ className = "fill-SP2" }) => {
  const titleId = useId();

  return (
    <svg
      width="43"
      height="27"
      viewBox="0 0 43 27"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={`fill-current ${className && className}`}
      aria-labelledby={titleId}
    >
      <title id={titleId}>Closing quotation mark</title>
      <path d="M2.6665 26.6667H10.6665L15.9998 16V-1.33514e-05H-0.000198364V16H7.9998L2.6665 26.6667ZM29.3331 26.6667H37.3331L42.6665 16V-1.33514e-05H26.6665V16H34.6665L29.3331 26.6667Z" />
    </svg>
  );
};

export default HeroQuoteClose;
